import { render } from "./aDelete.vue?vue&type=template&id=990380aa&ts=true"
import script from "./aDelete.vue?vue&type=script&lang=ts"
export * from "./aDelete.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__